"use client";

import { useState } from "react";
import AddThankYouModal from "@/app/components/appcomponents/AddThankYouModal";
import StepZero from "./StepZero";
import KeeperOrderModal from "./KeeperOrderModal";
import CandleOrderModal from "./CandleOrderModal";
import HighlightOrderModal from "./HighlightOrderModal";
import PastMemorialModal from "./PastMemorialModal";

/**
 * The order popups of the site, one entry point.
 *   product: "keeper" | "candle" | "highlight" | "thank_you" | "memory" | "past"
 *   obituary: the memory page, when the visitor is already on it (then Step 0 is skipped)
 *   preset: the choice already made on the Cenik page ("free" | "keeper_1y" | "keeper_5y" | "candle_1y" | "candle_5y")
 * Without an obituary, Step 0 asks for the memory page first, so the popups after it are the same everywhere.
 */
export default function OrderFlow({ product, obituary: initial = null, preset = "", onClose }) {
  const [obituary, setObituary] = useState(initial);

  // A new memory page for somebody who died years ago: it has its own four steps and no memory page to start from.
  if (product === "past") {
    return <PastMemorialModal onClose={onClose} />;
  }
  if (product === "highlight") {
    return <HighlightOrderModal obituary={initial} onClose={onClose} />;
  }
  if (!obituary) {
    return <StepZero product={product} onSelect={setObituary} onClose={onClose} />;
  }
  if (product === "keeper") {
    return <KeeperOrderModal obituary={obituary} preset={preset} onClose={onClose} />;
  }
  if (product === "candle") {
    return <CandleOrderModal obituary={obituary} preset={preset} onClose={onClose} />;
  }
  return (
    <AddThankYouModal
      obituary={obituary}
      kind={product === "memory" ? "spomin" : "zahvala"}
      onClose={onClose}
    />
  );
}
